"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class PreferencesModel {
    get appName() {
        return this._appName;
    }
    constructor(json) {
        if (json) {
            Object.keys(json).forEach((key) => {
                // appName is a getter only. child classes should set _appName directly.
                if (key !== 'appName' && key !== '_appName') {
                    this[key] = json[key];
                }
            });
        }
        this.setDefaults();
    }
    toJSON() {
        return {
            _id: this._id,
            appName: this._appName,
            sfUserId: this.sfUserId,
            configJson: this.configJson
        };
    }
}
exports.PreferencesModel = PreferencesModel;
class DesktopPreferencesModel extends PreferencesModel {
    constructor(json) {
        super(json);
    }
    setDefaults() {
        this._appName = 'desktop';
        const defaultConfig = {
            addFollowUp: true,
            showOptions: false,
            openTasks: true
        };
        // set default config values if they weren't already assigned
        this.configJson = Object.assign({}, defaultConfig, this.configJson);
    }
}
exports.DesktopPreferencesModel = DesktopPreferencesModel;
//# sourceMappingURL=preferences.model.js.map